import { LAYOUTS, ModalAlignmentEnum, } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { isMobile } from "../../../configs/utils";
import { heightMap } from "../../../configs/height";
import { ACTION } from './types';
import { downloadCollateral, goBack, previewAction, uploadImageToS3 } from "./action";
import { partnerApi } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import SharedPropsService, { getBuildType } from "../../../SharedPropsService";
const _isMobile = isMobile();
export const template = async (imageUrl, height, partnerData, file_name, buildType, collateralCategory) => ({
    layout: {
        id: ROUTE.COLLATERAL_DOWNLOAD_INFO,
        type: _isMobile ? LAYOUTS.LIST : LAYOUTS.MODAL,
        style: {
            isPartnerPlatform: true,
            alignment: ModalAlignmentEnum.RIGHT,
            height: heightMap[ROUTE.COLLATERAL_DOWNLOAD_INFO]
        },
        widgets: [{ id: 'collateralDownloadInfoScreen', type: WIDGET.COLLATERAL_DOWNLOAD_INFO_SCREEN }],
    },
    datastore: {
        collateralDownloadInfoScreen: {
            previewUrl: imageUrl,
            height: height,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.COLLATERAL_DOWNLOAD_INFO,
                payload: {}
            },
            previewAction: {
                type: ACTION.NAVIGATE_PREVIEW_SCREEN,
                routeId: ROUTE.COLLATERAL_DOWNLOAD_INFO,
                payload: {}
            },
            partnerData: partnerData,
            downloadAction: {
                type: ACTION.DOWNLOAD_COLLATERAL,
                routeId: ROUTE.COLLATERAL_DOWNLOAD_INFO,
                payload: {}
            },
            uploadImageToS3: {
                type: ACTION.UPLOAD_IMAGE_TO_S3,
                routeId: ROUTE.COLLATERAL_DOWNLOAD_INFO
            },
            downloadLoading: false,
            previewLoading: false,
            fileName: file_name,
            isMobile: _isMobile,
            uploadingImagetoS3: false,
            uploadedImagetoS3: false,
            buildType: buildType,
            collateralCategory: collateralCategory
        }
    },
});
export const collateralDownloadInfo = {
    onLoad: async ({ asyncStorage, network, getHeight }, { imageUrl, file_name, collateralCategory }) => {
        const userContextResponse = await network.post(partnerApi.userContext, {}, { headers: await getAppHeader() });
        const partnerData = userContextResponse.data.linkedPartnerAccounts[0];
        await SharedPropsService.setUser(userContextResponse.data);
        const buildType = getBuildType();
        return Promise.resolve(template(imageUrl, getHeight(), partnerData, file_name, buildType, collateralCategory));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.NAVIGATE_PREVIEW_SCREEN]: previewAction,
        [ACTION.DOWNLOAD_COLLATERAL]: downloadCollateral,
        [ACTION.UPLOAD_IMAGE_TO_S3]: uploadImageToS3,
    },
};
